<template>
  <div>
    <Timeline :id="profile" sourceType="profile" :options="{ tweetLimit }" />
  </div>
</template>

<script>
import { Timeline } from 'vue-tweet-embed'
export default {
  components: { Timeline },
  props: {
    profile: {
      type: String,
      default: 'twitterdev'
    },
    tweetLimit: {
      type: String,
      default: '3'
    }
  }
}
</script>
